import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect, useCallback, useContext, createContext } from 'react';
import { u as useLocalization } from '../LocalizationContext-a82461b5.js';
import Modal from '../ui/Modal.js';
import { B as BROWSER_SUPPORT_MIME_TYPE_LIST, h as VOICE_RECORDER_AUDIO_BIT_RATE, b as VOICE_MESSAGE_FILE_NAME, c as VOICE_MESSAGE_MIME_TYPE } from '../consts-fa6ab3c0.js';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import 'react-dom';
import '../index-a9101009.js';
import '../ui/Button.js';
import '../index-6420013c.js';
import 'prop-types';
import '../ui/Icon.js';
import '../ui/IconButton.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../MediaQueryContext-d6110905.js';
import '../withSendbird.js';

// Input props of VoiceRecorder

// Output of VoiceRecorder

var noop = function noop() {/* noop */};
var Context = /*#__PURE__*/createContext({
  start: noop,
  stop: noop,
  isRecordable: false
});
var VoiceRecorderProvider = function VoiceRecorderProvider(props) {
  var _BROWSER_SUPPORT_MIME;
  var children = props.children;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config;
  var logger = config.logger,
    isVoiceMessageEnabled = config.isVoiceMessageEnabled;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mediaRecorder = _useState2[0],
    setMediaRecorder = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRecordable = _useState4[0],
    setIsRecordable = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    permissionWarning = _useState6[0],
    setPermissionWarning = _useState6[1];
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet;
  var checkPermission = function checkPermission() {
    try {
      // Type '"microphone"' is not assignable to type 'PermissionName'.ts(2322)
      // this is typescript issue
      // https://github.com/microsoft/TypeScript/issues/33923
      // @ts-expect-error
      navigator.permissions.query({
        name: 'microphone'
      }).then(function (result) {
        if (result.state === 'denied') {
          logger.warning('VoiceRecorder: Permission denied.');
          setPermissionWarning(true);
        }
      });
    } catch (error) {
      logger.warning('VoiceRecorder: Failed to check permission.', error);
    }
  };
  var browserSupportMimeType = (_BROWSER_SUPPORT_MIME = BROWSER_SUPPORT_MIME_TYPE_LIST.find(function (mimeType) {
    return MediaRecorder.isTypeSupported(mimeType);
  })) !== null && _BROWSER_SUPPORT_MIME !== void 0 ? _BROWSER_SUPPORT_MIME : '';
  if (!browserSupportMimeType) {
    logger.error('VoiceRecorder: Browser does not support mimeType', {
      mimmeTypes: BROWSER_SUPPORT_MIME_TYPE_LIST
    });
  }
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    webAudioUtils = _useState8[0],
    setWebAudioUtils = _useState8[1];
  useEffect(function () {
    if (isVoiceMessageEnabled && !webAudioUtils) {
      import('../WebAudioUtils-b0d3696c.js').then(function (data) {
        setWebAudioUtils(data);
      });
    }
  }, []);
  var start = useCallback(function (eventHandler) {
    var _navigator, _navigator$mediaDevic, _navigator$mediaDevic2;
    if (isVoiceMessageEnabled && !webAudioUtils) {
      logger.error('VoiceRecorder: Recording audio processor is being loaded.');
      return;
    }
    logger.info('VoiceRecorder: Start recording.');
    if (mediaRecorder) {
      stop();
      logger.info('VoiceRecorder: Previous mediaRecorder is stopped.');
    }
    checkPermission();
    (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$mediaDevic = _navigator.mediaDevices) === null || _navigator$mediaDevic === void 0 ? void 0 : (_navigator$mediaDevic2 = _navigator$mediaDevic.getUserMedia) === null || _navigator$mediaDevic2 === void 0 ? void 0 : _navigator$mediaDevic2.call(_navigator$mediaDevic, {
      audio: true
    }).then(function (stream) {
      logger.info('VoiceRecorder: Succeeded getting media stream.', stream);
      setIsRecordable(true);
      var mediaRecorder = new MediaRecorder(stream, {
        mimeType: browserSupportMimeType,
        audioBitsPerSecond: VOICE_RECORDER_AUDIO_BIT_RATE
      });
      mediaRecorder.ondataavailable = function (e) {
        var _stream$getAudioTrack, _stream$getAudioTrack2, _stream$getAudioTrack3;
        // when recording stops
        logger.info('VoiceRecorder: Succeeded getting an available data.', e.data);
        var audioFile = new File([e.data], VOICE_MESSAGE_FILE_NAME, {
          lastModified: new Date().getTime(),
          type: VOICE_MESSAGE_MIME_TYPE
        });
        webAudioUtils === null || webAudioUtils === void 0 ? void 0 : webAudioUtils.downsampleToWav(audioFile, function (buffer) {
          var mp3Buffer = webAudioUtils === null || webAudioUtils === void 0 ? void 0 : webAudioUtils.encodeMp3(buffer);
          var mp3blob = new Blob(mp3Buffer, {
            type: VOICE_MESSAGE_MIME_TYPE
          });
          var convertedAudioFile = new File([mp3blob], VOICE_MESSAGE_FILE_NAME, {
            lastModified: new Date().getTime(),
            type: VOICE_MESSAGE_MIME_TYPE
          });
          eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler.onRecordingEnded(convertedAudioFile);
          logger.info('VoiceRecorder: Succeeded converting audio file.', convertedAudioFile);
        });
        stream === null || stream === void 0 ? void 0 : (_stream$getAudioTrack = stream.getAudioTracks) === null || _stream$getAudioTrack === void 0 ? void 0 : (_stream$getAudioTrack2 = (_stream$getAudioTrack3 = _stream$getAudioTrack.call(stream)).forEach) === null || _stream$getAudioTrack2 === void 0 ? void 0 : _stream$getAudioTrack2.call(_stream$getAudioTrack3, function (track) {
          return track === null || track === void 0 ? void 0 : track.stop();
        });
        setIsRecordable(false);
      };
      mediaRecorder === null || mediaRecorder === void 0 ? void 0 : mediaRecorder.start();
      setMediaRecorder(mediaRecorder);
      eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler.onRecordingStarted();
    }).catch(function (err) {
      logger.error('VoiceRecorder: Failed getting media stream.', err);
      setMediaRecorder(null);
    });
  }, [mediaRecorder, webAudioUtils]);
  var stop = useCallback(function () {
    // Stop recording
    mediaRecorder === null || mediaRecorder === void 0 ? void 0 : mediaRecorder.stop();
    setMediaRecorder(null);
    setIsRecordable(false);
    logger.info('VoiceRecorder: Stop recording.');
  }, [mediaRecorder]);
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: {
      start: start,
      stop: stop,
      isRecordable: isRecordable
    }
  }, children, permissionWarning && /*#__PURE__*/React__default.createElement(Modal, {
    hideFooter: true,
    onCancel: function onCancel() {
      return setPermissionWarning(false);
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, stringSet.VOICE_RECORDING_PERMISSION_DENIED)));
};
var useVoiceRecorderContext = function useVoiceRecorderContext() {
  return useContext(Context);
};
var index = {
  VoiceRecorderProvider: VoiceRecorderProvider,
  useVoiceRecorderContext: useVoiceRecorderContext
};
export { VoiceRecorderProvider, index as default, useVoiceRecorderContext };